// extracted by mini-css-extract-plugin
export default {"separator":"ZAW9+e6rT12NEz+1QqR9ZQ=="};